import QUIZ from '../../clients/quiz'

const fetchQuizById = async quizId => {
  const route = `quizzes/${quizId}`
  return QUIZ.get(route)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

const fetchQuizAttemptsByQuizId = async quizId => {
  const route = `quizzes/${quizId}/attempts`
  return QUIZ.get(route)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

const postQuizAttemptByQuizId = async quizId => {
  const route = `quizzes/${quizId}/attempts`
  return QUIZ.post(route, {})
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

const putQuizAttemptByQuizId = async userAttemptAndEntityIds => {
  const { quizId, attemptId, submission } = userAttemptAndEntityIds
  const route = `quizzes/${quizId}/attempts/${attemptId}`
  const payload = {
    status: 'finished',
    questions: submission,
  }
  return QUIZ.put(route, payload)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export {
  fetchQuizById,
  fetchQuizAttemptsByQuizId,
  postQuizAttemptByQuizId,
  putQuizAttemptByQuizId,
}
